import { HexString } from 'shared/entities/color';

const isWhiteHexColor = (color: HexString): boolean =>
  color === '#fff' || color === '#ffffff';

export default isWhiteHexColor;
